import { Button } from '@sparemin/blockhead';
import React from 'react';
import { block } from './utils';

export interface EddyEditTranscriptModalHeaderProps {
  isTranscriptLoaded: boolean;
  onSave?: () => void;
  onCancel?: () => void;
}

const EddyEditTranscriptModalHeader: React.FC<EddyEditTranscriptModalHeaderProps> = ({
  isTranscriptLoaded,
  onSave,
  onCancel,
}) => {
  return (
    <div className={block('header')}>
      <Button
        variant="ghost"
        className={block('header-action')}
        onPress={onCancel}
      >
        cancel
      </Button>

      <Button
        variant="solid"
        className={block('header-action')}
        isDisabled={!isTranscriptLoaded}
        onPress={onSave}
      >
        save changes
      </Button>
    </div>
  );
};

export default EddyEditTranscriptModalHeader;
